import { createRouter, createWebHistory } from 'vue-router'
import RengongYlqRwTestView from '../views/rengongcuiping/RengongYlqRwKFView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongInfoView.vue')
  },
  {
    path: '/zcpInfo',
    name: 'zcpInfo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/zcp/zcpInfoView.vue')
  },
  {
    path: '/zcpList',
    name: 'zcpList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/zcp/zcpListView.vue')
  },
  {
    path: '/zcpSuccessList',
    name: 'zcpSuccessList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/zcp/zcpSuccessListView.vue')
  },
  /*{
    path: '/SaleRenwu',
    name: 'SaleRenwu',
    component: RenwuView
  },
  {
    path: '/SaleDclTh',
    name: 'SaleDclTh',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/saleafter/DclTHView.vue')
  },
  {
    path: '/SaleRMDKPI',
    name: 'SaleRMDKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/saleafter/SaleRMDKPIView.vue')
  },
  {
    path: '/SaleSingleKPI',
    name: 'SaleSingleKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/saleafter/SaleSingleKPIView.vue')
  },
  {
    path: '/SaleSuccessKPI',
    name: 'SaleSuccessKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/saleafter/SaleSuccessKPIView.vue')
  },
  {
    path: '/SaleRefundList',
    name: 'SaleRefundList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/saleafter/SaleRefundListView.vue')
  },
  */
  {
    path: '/rengongInfo',
    name: 'rengongInfo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongInfoView.vue')
  },
  {
    path: '/rengongWlq',
    name: 'rengongWlq',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongWlqView.vue')
  },
  {
    path: '/RengongYlqRw',
    name: 'RengongYlqRw',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongYlqRwView.vue')
  },
  {
    path: '/RengongYlqRwNew',
    name: 'RengongYlqRwNew',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongYlqRwNewView.vue')
  },
  {
    path: '/RengongFeigeMessage',
    name: 'RengongFeigeMessage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongFeigeMessage.vue')
  },
  {
    path: '/FeigeOrderMessage',
    name: 'FeigeOrderMessage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/FeigeOrderMessageView.vue')
  },
  {
    path: '/RengongFeigeMessageList',
    name: 'RengongFeigeMessageList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongFeigeMessageList.vue')
  },
  {
    path: '/RengongFeigeSendList',
    name: 'RengongFeigeSendList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongFeigeSendListView.vue')
  },
  {
    path: '/RengongFeigeMessageupdate',
    name: 'RengongFeigeMessageupdate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongFeigeMessageupdate.vue')
  },
  {
    path: '/RengongCPKPI',
    name: 'RengongCPKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongCPKPIView.vue')
  },
  {
    path: '/RengongKFKPI',
    name: 'RengongKFKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongKFKPIView.vue')
  },
  {
    path: '/RengongGRKPI',
    name: 'RengongGRKPI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongGrKPIView.vue')
  },
  {
    path: '/RengongDSH',
    name: 'RengongDSH',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongDSHView.vue')
  },
  {
    path: '/RengongCXTool',
    name: 'RengongCXTool',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongCXToolView.vue')
  },
  {
    path: '/RengongCuikuan',
    name: 'RengongCuikuan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/cuikuan/RengongCuikuanView.vue')
  },
  {
    path: '/Rengongbailing',
    name: 'Rengongbailing',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/rengongcuiping/RengongbailingView.vue')
  },
  {
    path: '/CuikuanKfKpi',
    name: 'CuikuanKfKpi',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/cuikuan/CuikuanKfKpiView.vue')
  },
  {
    path: '/CuikuanJixiao',
    name: 'CuikuanJixiao',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/cuikuan/CuikuanJixiaoView.vue')
  },
  {
    path: '/SmsCreate',
    name: 'SmsCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/sms/SmsCreateView.vue')
  },
  {
    path: '/Smslist',
    name: 'Smslist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/sms/SmslistView.vue')
  },
  {
    path: '/SmsDonelist',
    name: 'SmsDonelist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/sms/SmsDonelistView.vue')
  },
  {
    path: '/SmsFeeChange',
    name: 'SmsFeeChange',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/smsfee/SmsFeeChangeView.vue')
  },
  {
    path: '/SmsFeeShareShop',
    name: 'SmsFeeShareShop',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/smsfee/SmsFeeShareShopView.vue')
  },
  /*{
    path: '/SmsFeeSH',
    name: 'SmsFeeSH',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/shouhou/SmsFeeSHView.vue')
  },
  {
    path: '/SmsFeeCPCL',
    name: 'SmsFeeCPCL',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/shouhou/SmsFeeCPCLView.vue')
  },
  {
    path: '/SmsFeeCreate',
    name: 'SmsFeeCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/shouhou/SmsFeeCreateView.vue')
  },
  {
    path: '/SmsFeeActList',
    name: 'SmsFeeActList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/shouhou/SmsFeeActListView.vue')
  },*/
  {
    path: '/PluginEdu',
    name: 'PluginEdu',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/plugin/PluginEduView.vue')
  },
  {
    path: '/Dzmdlist',
    name: 'Dzmdlist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/dzmd/DzmdlistView.vue')
  },
  {
    path: '/DzmdTempMan',
    name: 'DzmdTempMan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/dzmd/DzmdTempManView.vue')
  },
  {
    path: '/DzmdTempSeting',
    name: 'DzmdTempSeting',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/dzmd/DzmdTempSetingView.vue')
  },
  /*{
    path: '/DzmdFHAddress',
    name: 'DzmdFHAddress',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/dzmd/DzmdFHAddressView.vue')
  },
  */
  {
    path: '/PrintDdy',
    name: 'PrintDdy',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/print/PrintDdyView.vue')
  },
  {
    path: '/PrintDykdd',
    name: 'PrintDykdd',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/print/PrintDykddView.vue')
  },
  {
    path: '/PrintManage',
    name: 'PrintManage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/print/PrintManageView.vue')
  },
  {
    path: '/JyManage',
    name: 'JyManage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/JyManage/JyManView.vue')
  },
  {
    path: '/KFSaleDcl',
    name: 'KFSaleDcl',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/KFSale/KFSaleDclView.vue')
  },
  
  {
    path: '/DataInfo',
    name: 'DataInfo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/DataManage/DataInfoView.vue')
  },
  {
    path: '/DataProPrice',
    name: 'DataProPrice',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/DataManage/DataProPriceView.vue')
  },
  
  {
    path: '/CheckAppin',
    name: 'CheckAppin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Index/IndexView.vue')
  },
  
  {
    path: '/RengongYlqRwTest',
    name: 'RengongYlqRwTest',
    component: RengongYlqRwTestView
  },
  /*
  {
    path: '/dashboard',
    name: 'dashboard',
    children:[{
      path: '/dashboard/analysis',
      name: 'analysis',
      component:AnalySis
    },
    {
      path: '/dashboard/monitor',
      name: 'monitor',
      component:MoniTor
    }]
  }*/
]
const phonenum = [
]
phonenum.map(item=>{
	let obj = {
			path: '/'+item,
			name: item,
			component: RengongYlqRwTestView
		}
	routes.push(obj)
})
if(window.keepLivingNowConfig != undefined && window.keepLivingNowConfig != null){
  if(window.keepLivingNowConfig.length){
    window.keepLivingNowConfig.map(item=>{
      let obj = {
          path: '/'+item,
          name: item,
          component: RengongYlqRwTestView
        }
      routes.push(obj)
    })
  }
}
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
